import { sdkFactory as wixAppmarketV1AppPlans_sdkFactory_appPlans } from './src/appmarket-v1-app-plans.frontend';
import { sdkFactory as wixDevcenterAppInstanceV1AppInstance_sdkFactory_appInstances } from './src/devcenter-app-instance-v1-app-instance.frontend';
import { sdkFactory as wixDevcenterBiEventsV1SendBiEventResponse_sdkFactory_biEvents } from './src/devcenter-bi-events-v1-send-bi-event-response.frontend';
import { sdkFactory as wixDevcenterCheckoutV1PurchasedItem_sdkFactory_billing } from './src/devcenter-checkout-v1-purchased-item.frontend';
import { sdkFactory as wixDevcenterScriptsV1ScriptProperties_sdkFactory_embeddedScripts } from './src/devcenter-scripts-v1-script-properties.frontend';
export function sdkFactory(args) {
    return {
        appPlans: wixAppmarketV1AppPlans_sdkFactory_appPlans(args),
        appInstances: wixDevcenterAppInstanceV1AppInstance_sdkFactory_appInstances(args),
        biEvents: wixDevcenterBiEventsV1SendBiEventResponse_sdkFactory_biEvents(args),
        billing: wixDevcenterCheckoutV1PurchasedItem_sdkFactory_billing(args),
        embeddedScripts: wixDevcenterScriptsV1ScriptProperties_sdkFactory_embeddedScripts(args),
    };
}
//# sourceMappingURL=index.frontend.js.map